import React, { useEffect, useState, useRef } from "react";
import Chart from "chart.js/auto";
import "./CadastroUsuarios.css";
import UsuarioModal from "./UsuarioModal";

export default function CadastroUsuarios() {
    const [aba, setAba] = useState(localStorage.getItem("abaUsuarios") || "dashboard");
    const chartRef1 = useRef(null);
    const chartRef2 = useRef(null);
    const chart1 = useRef(null);
    const chart2 = useRef(null);

    const [usuarios, setUsuarios] = useState(() => {
        const saved = localStorage.getItem("usuarios");
        return saved ? JSON.parse(saved) : [];
    });

    const [execucoes, setExecucoes] = useState([12, 19, 7, 14]);
    const [statusExecucoes, setStatusExecucoes] = useState([78, 12, 10]);
    const [modalAberto, setModalAberto] = useState(false);

    const [novoUsuario, setNovoUsuario] = useState({
        nome: "",
        email: "",
        cargo: "",
        departamento: "",
        nivelAcesso: "",
        matricula: "",
        endereco: "",
        cpf: ""
    });

    // Persiste aba
    useEffect(() => {
        localStorage.setItem("abaUsuarios", aba);
    }, [aba]);

    // Persiste usuários
    useEffect(() => {
        localStorage.setItem("usuarios", JSON.stringify(usuarios));
    }, [usuarios]);

    // Atualiza gráficos
    useEffect(() => {
        if (aba === "dashboard") {
            if (chart1.current) chart1.current.destroy();
            if (chart2.current) chart2.current.destroy();

            const ctx1 = chartRef1.current.getContext("2d");
            chart1.current = new Chart(ctx1, {
                type: "bar",
                data: {
                    labels: ["Robô A", "Robô B", "Robô C", "Robô D"],
                    datasets: [
                        {
                            label: "Execuções Hoje",
                            data: execucoes,
                            backgroundColor: ["#4f46e5", "#6366f1", "#818cf8", "#a5b4fc"],
                        },
                    ],
                },
                options: { plugins: { legend: { display: false } } },
            });

            const ctx2 = chartRef2.current.getContext("2d");
            chart2.current = new Chart(ctx2, {
                type: "doughnut",
                data: {
                    labels: ["Sucesso", "Falha", "Em execução"],
                    datasets: [
                        {
                            data: statusExecucoes,
                            backgroundColor: ["#16a34a", "#dc2626", "#facc15"],
                        },
                    ],
                },
                options: { plugins: { legend: { position: "bottom" } } },
            });
        }
    }, [aba, execucoes, statusExecucoes]);

    // Simula robô rodando
    useEffect(() => {
        const intervalo = setInterval(() => {
            setExecucoes((prev) => prev.map((v) => v + Math.floor(Math.random() * 3)));
            setStatusExecucoes((prev) => [
                prev[0] + Math.floor(Math.random() * 2),
                prev[1] + Math.floor(Math.random() * 1),
                prev[2],
            ]);
        }, 90000);
        return () => clearInterval(intervalo);
    }, []);

    const handleChange = (e) => {
        setNovoUsuario({ ...novoUsuario, [e.target.name]: e.target.value });
    };

    const adicionarUsuario = (e) => {
        e.preventDefault();
        if (!novoUsuario.nome.trim() || !novoUsuario.email.trim()) return;
        setUsuarios([...usuarios, { id: Date.now(), ...novoUsuario }]);
        setNovoUsuario({
            nome: "",
            email: "",
            cargo: "",
            departamento: "",
            nivelAcesso: "",
            matricula: "",
            endereco: "",
            cpf: ""
        });
    };

    const deletarUsuario = (id) => {
        // if (window.confirm("Deseja realmente excluir este usuário?")) {
            setUsuarios(usuarios.filter((u) => u.id !== id));
        // }
    };

    return (
        <div className="cadastro-container">
            <div className="tabs">
                <button
                    className={aba === "dashboard" ? "active" : ""}
                    onClick={() => setAba("dashboard")}
                >
                    📊 Dashboard
                </button>
                <button
                    className={aba === "usuarios" ? "active" : ""}
                    onClick={() => setAba("usuarios")}
                >
                    👥 Usuários
                </button>
            </div>

            <div className="tab-content">
                {aba === "dashboard" && (
                    <div className="dashboard">
                        <div className="chart-card">
                            <h3>Execuções por Robô</h3>
                            <canvas ref={chartRef1}></canvas>
                        </div>
                        <div className="chart-card">
                            <h3>Status das Execuções</h3>
                            <canvas ref={chartRef2}></canvas>
                        </div>
                    </div>
                )}

                {aba === "usuarios" && (
                    <div className="usuarios">
                        <div className="divBtnAddUser">
                            <button className="add-btn" onClick={() => setModalAberto(true)}>
                                ➕ Adicionar Usuário
                            </button>
                        </div>
                        {modalAberto && (
                            <UsuarioModal
                                novoUsuario={novoUsuario}
                                onChange={handleChange}
                                onSalvar={adicionarUsuario}
                                onFechar={() => setModalAberto(false)}
                            />
                        )}

                        {usuarios.length === 0 ? (
                            <p>Nenhum usuário cadastrado.</p>
                        ) : (
                            <table>
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Email</th>
                                        <th>Cargo</th>
                                        <th>Departamento</th>
                                        <th>Nível</th>
                                        <th>Matrícula</th>
                                        <th>Endereço</th>
                                        <th>CPF</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {usuarios.map((u) => (
                                        <tr key={u.id}>
                                            <td>{u.nome}</td>
                                            <td>{u.email}</td>
                                            <td>{u.cargo}</td>
                                            <td>{u.departamento}</td>
                                            <td>{u.nivelAcesso}</td>
                                            <td>{u.matricula}</td>
                                            <td>{u.endereco}</td>
                                            <td>{u.cpf}</td>
                                            <td>
                                                <button
                                                    className="del-btn"
                                                    onClick={() => deletarUsuario(u.id)}
                                                >
                                                    🗑️
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
